class ProductListTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
    this.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('keydown', this.#handleKeydown);
  }

  get #tabs() {
    return Array.from(this.querySelectorAll('[role="tab"]'));
  }

  get #panels() {
    return Array.from(this.querySelectorAll('[role="tabpanel"]'));
  }

  get #viewAllLinks() {
    return Array.from(this.querySelectorAll('[data-tab-index]'));
  }

  #handleClick = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    const index = this.#tabs.indexOf(tab);
    if (index >= 0) this.#selectTab(index);
  };

  #handleKeydown = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    const tabs = this.#tabs;
    const index = tabs.indexOf(tab);
    let next = -1;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    if (next >= 0) {
      event.preventDefault();
      this.#selectTab(next);
    }
  };

  #selectTab(index) {
    this.#tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', active ? '0' : '-1');
      if (active) tab.focus({ preventScroll: true });
    });
    this.#panels.forEach((panel, i) => panel.classList.toggle('hidden', i !== index));
    this.#viewAllLinks.forEach((link) =>
      link.classList.toggle('hidden', Number(link.dataset.tabIndex) !== index)
    );
  }
}

customElements.define('product-list-tabs', ProductListTabs);
